export default class myClass{
	constructor($location, $scope, info, $rootScope){
		this.scope    = $scope;
		this.location = $location;
		this.info     = info;

		this.scope.showMenu = false;

		this.scope.$on('$routeChangeStart', (next, current) => {
			let location = $location.path();
			let arLocation = location.split('/');
			this.scope.menu	= arLocation[1];
			this.scope.showMenu = false;
		});
		this.scope.display     = [];
		this.scope.show        = this.show.bind(this);
		this.scope.currentPage = this.currentPage.bind(this);
        this.scope.logout      = this.logout.bind(this);
		this.scope.permiso     = this.permiso.bind(this);
		this.scope.showMenuMobile = this.showMenuMobile.bind(this);
		this.scope.cliente = localStorage.getItem('cliente');
	}

	show(data){
		if (this.scope.display.includes(data)) {
			this.scope.display = this.arrayRemove(this.scope.display, data);
		}else{
			this.scope.display.push(data);
		}
	}

	currentPage(data){
		this.scope.cliente = localStorage.getItem('cliente');
		let locationArray = this.location.path().split('/');
		let here = locationArray[locationArray.length -1];
		if (here == data) {
			return true;
		}else{
			return false;
		}
	}

	logout(){
		localStorage.removeItem('token');
		localStorage.removeItem('cliente');
		localStorage.removeItem('flag_tecnico');
        window.location.reload();
    }

	permiso(nombre){
		this.scope.cliente = localStorage.getItem('cliente');
		if (this.info.get('permisos') === undefined) {
			return false;
		}

		let diccionario = {
			'preincidencia': 'pi',
			'incidencia': 'in',
			'ott': 'ot',
			'equipos': 'eq',
			'administracion': 'adm',
			'panelcontrol': 'pc',
			'dashboard': 'dsb',
			'reporte': 'rp',
			'pdf_masivo': 'pdf_masivo',
			'por_agendar': 'por_agendar'
		};

		let aux = diccionario[nombre];

		if(aux === 'adm' && this.info.get('permisos')[aux]) {
            return true;
		} else if(aux === 'pdf_masivo' && this.info.get('permisos')[aux]) {
            return true;
		} else if (aux === 'por_agendar' && this.info.get('permisos')[aux]) {
			return true;
		} else if (this.info.get('permisos')[aux] && this.info.get('permisos')[aux].r){
			return true;
		}else {
			return false;
		}
	}

	showMenuMobile(){
		this.scope.cliente = localStorage.getItem('cliente');
		this.scope.showMenu = !this.scope.showMenu;
	}

	arrayRemove(arr, value) {

		return arr.filter(function(ele){
			return ele != value;
		});
	 
	 }
}



// WEBPACK FOOTER //
// ./app/js/controllers/menu/menu.js